import React from 'react';
import { useFilterDropdownPosition } from 'src/components/star-grid/hooks/useFilterDropdownPosition';
import styles from 'src/components/star-grid/components/styles/FilterDropdown.module.scss';
interface Props {
  readonly controlId: string;
  readonly children?: React.ReactNode;
}
export const FilterDropdownHeader: React.FC<Props> = ({ controlId, children }) => {
  const marker = useFilterDropdownPosition(controlId);
  return (
    <>
      <span className={styles.marker} ref={marker} aria-hidden="true" />
      {children}
    </>
  );
};
